export const baseUrlApi = "https://api.vcs-vn.com"
